import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as AnnouncementIcon } from '../../../../../assets/icons/announcement.svg';
import { SubTitle } from '../../../../../components/v2/Card';
import ToggleButtonGroup from '../../../../components/ToggleButtonGroup';

import {
  NotificationRow,
  NotificationIconWrap,
  NotificationText,
  NotificationTitle,
} from './styles';
import texts from './texts.json';

const NotificationOption = {
  ON: 'ON',
  OFF: 'OFF',
};

const TOGGLE_OPTIONS = [
  { value: NotificationOption.OFF, label: texts.toggleOff },
  { value: NotificationOption.ON, label: texts.toggleOn },
];

const NotificationToggle = ({ checked, onChange, disabled }) => (
  <NotificationRow>
    <NotificationIconWrap>
      <AnnouncementIcon />
    </NotificationIconWrap>
    <NotificationText>
      <NotificationTitle>{texts.title}</NotificationTitle>
      <SubTitle>{texts.subtitle}</SubTitle>
    </NotificationText>
    <ToggleButtonGroup
      value={checked ? NotificationOption.ON : NotificationOption.OFF}
      options={TOGGLE_OPTIONS}
      onChange={(value) => onChange(value === NotificationOption.ON)}
      disabled={disabled}
    />
  </NotificationRow>
);

NotificationToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

NotificationToggle.defaultProps = {
  disabled: false,
};

export default NotificationToggle;
